module.exports = __webpack_public_path__ + "static/media/ASOS-Oversized-Hoodie-In-Pink-for-Men-Lyst_thumb.80119bc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/thumbs/ASOS-Oversized-Hoodie-In-Pink-for-Men-Lyst_thumb.png
// module id = 261
// module chunks = 0